import { useEffect, useRef, useState } from 'react';

const Counter = props => {
  const { duration = 500, maxSteps = 50 } = props;
  const [value, setValue] = useState(0);
  const lastValue = useRef(props.value);

  useEffect(() => {
    const diff = props.value - (lastValue.current || 0);

    if (diff) {
      lastValue.current = props.value;
      const steps = Math.max(Math.min(maxSteps, Math.abs(diff)), 1);
      let step = 0;

      const timer = setInterval(
        () =>
          setValue(x => {
            ++step;
            const val = x + Math.floor((diff * step) / steps);

            if ((diff > 0 && val > props.value) || (diff < 0 && val < props.value)) {
              clearInterval(timer);
              return props.value;
            }

            return val;
          }),
        duration / steps
      );

      return () => {
        clearInterval(timer);
      };
    } else {
      setValue(props.value);
    }
  }, [props.value]);

  return typeof props.children === 'function'
    ? props.children(typeof value === 'number' ? value.toLocaleString() : undefined)
    : null;
};

export default Counter;
